import { render, staticRenderFns } from "./codigoTemporal.vue?vue&type=template&id=01b2e84c"
import script from "./codigoTemporal.vue?vue&type=script&lang=js"
export * from "./codigoTemporal.vue?vue&type=script&lang=js"
import style0 from "./codigoTemporal.vue?vue&type=style&index=0&id=01b2e84c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports